package com.tovtalk.data.cache

import com.russhwolf.settings.Settings
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
class LocalCacheManager(
    private val settings: Settings
) {
    // User profile
    fun saveUserProfile(profileJson: String) {
        settings.putString(USER_PROFILE_KEY, profileJson)
        settings.putLong(USER_PROFILE_TIMESTAMP, Clock.System.now().toEpochMilliseconds())
    }

    fun getUserProfile(): String? {
        val timestamp = settings.getLongOrNull(USER_PROFILE_TIMESTAMP) ?: return null
        if (isStale(timestamp, PROFILE_TTL_MS)) return null
        return settings.getStringOrNull(USER_PROFILE_KEY)
    }

    // App settings
    fun saveSettings(settingsJson: String) {
        settings.putString(SETTINGS_KEY, settingsJson)
        settings.putLong(SETTINGS_TIMESTAMP, Clock.System.now().toEpochMilliseconds())
    }

    fun getSettings(): String? {
        val timestamp = settings.getLongOrNull(SETTINGS_TIMESTAMP) ?: return null
        if (isStale(timestamp, SETTINGS_TTL_MS)) return null
        return settings.getStringOrNull(SETTINGS_KEY)
    }

    fun invalidate(key: String) {
        settings.remove(key)
        settings.remove("${key}_timestamp")
    }

    private fun isStale(timestampMs: Long, ttlMs: Long): Boolean {
        val now = Clock.System.now().toEpochMilliseconds()
        return (now - timestampMs) > ttlMs
    }

    companion object {
        private const val USER_PROFILE_KEY = "user_profile"
        private const val USER_PROFILE_TIMESTAMP = "user_profile_timestamp"
        private const val SETTINGS_KEY = "app_settings"
        private const val SETTINGS_TIMESTAMP = "app_settings_timestamp"

        const val PROFILE_TTL_MS = 3_600_000L        // 1 hour
        const val SETTINGS_TTL_MS = 86_400_000L       // 24 hours
    }
}
